/* global ksAPI */

const studentsPopup = () => {
  const popups = document.querySelectorAll('.js-students-popup');

  if (popups) {
    popups.forEach(popup => {
      const closeBtns = popup.querySelectorAll('.js-students-popup-close');
      const links = document.querySelectorAll('.js-students-popup-link');
      const content = popup.querySelector('.js-students-popup-content');
      const loader = popup.querySelector('.js-students-popup-loader');

      links.forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          popup.classList.remove('u-hidden');
          loader.classList.add('is-loading');

          const { post } = link.dataset;
          const ajaxUrl = document.querySelector('meta[name="adjx"]').content;
          const restUrl = `${ksAPI.rest.url}wp/v2/`;
          const ajaxData = {
            action: 'ks_get_post_content',
            rest_url: restUrl,
            post,
          };

          const ajaxParameters = Object.entries(ajaxData)
            .map(e => e.join('='))
            .join('&');

          const xhr = new XMLHttpRequest();
          xhr.open('POST', ajaxUrl, true);

          xhr.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded;',
          );

          xhr.onload = () => {
            const { response } = xhr;
            if (!response) {
              return;
            }

            content.innerHTML = response;
            loader.classList.remove('is-loading');
            const images = document.querySelectorAll('.js-gallery-img');
            if (images) {
              document.showPopup();
            }
          };
          // eslint-disable-next-line no-unused-vars
          xhr.onerror = response => {
            // eslint-disable-next-line no-console
            // console.error(response);
          };

          xhr.send(ajaxParameters);
        });
      });

      closeBtns.forEach(close => {
        close.addEventListener('click', () => {
          popup.classList.add('u-hidden');
          loader.classList.remove('is-loading');
          content.innerHTML = '';
        });
      });
    });
  }
};

export default studentsPopup;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/studentsPopup.js